export type NavStep = 'planner' | 'plansettings' | 'accessory' | 'result' | 'cycles'

export const navStepsWall: NavStep[] = ['plansettings', 'planner', 'cycles', 'accessory', 'result']
export const navStepsSlab: NavStep[] = ['plansettings', 'planner', 'result']
